// @flow
import React, { Fragment, PureComponent } from 'react';
import type { FullUserType } from 'types/User';
import { dynamicClassName } from 'utils/dynamicClassName';
import { handleTagEvent } from 'utils/tagManagerUtils';
import SocialButtons from 'containers/social/SocialButtonsContainer';

export type DispatchProps = {
  displayModal: (modalObject: string, content: Object, force: boolean) => void
};

export type StateProps = {
  userPref: FullUserType
};

type Props = StateProps & {
  id: string,
  category?: string,
  title: string,
  date: Date | string,
  label: string,
  src: string,
  label_download: string,
  sidebar?: boolean
} & DispatchProps;

type State = {
  shareOpen: boolean
};

class CentenaireDownload extends PureComponent<Props, State> {
  props: Props;

  static defaultProps = {
    id: '',
    title: 'title',
    date: new Date(),
    label: 'label',
    src: '#',
    label_download: 'Télécharger'
  };

  state = {
    shareOpen: false
  };

  toggleShare = () => {
    this.setState({ shareOpen: !this.state.shareOpen });
  };

  renderSocialButtons = (): React$Element<any> => {
    const { id, title } = this.props;
    const url = window.location.origin + `/histoires-de-rugby/${id}`;
    return <SocialButtons url={url} title={title} />;
  };

  onDownloadClick = (e: MouseEvent) => {
    const { pathname } = window.location;
    const { displayModal, title, src, userPref } = this.props;
    e.preventDefault();
    displayModal('MODAL_CENTENAIRE_FORM_DOWNLOAD', { title: title, src: src }, false);
    return handleTagEvent(
      'telechargement_document',
      title,
      '',
      userPref,
      handleTagEvent(
        'module_document',
        `download document ${title}`,
        pathname,
        userPref,
        handleTagEvent('module_contenu', `clic ${title}`, pathname, userPref)
      )
    );
  };

  render() {
    const { title, label_download } = this.props;
    const classNamesShareOpen = dynamicClassName('share share--left');
    this.state.shareOpen && classNamesShareOpen.add('is-open');

    return (
      <Fragment>
        <a
          title={`Télécharger le document ${title}`}
          href="#"
          onClick={this.onDownloadClick}
          download
          rel="noopener noreferrer"
          className="btn btn--primary btn--gold btn--full"
        >
          <i className="icon icon-download is-inline" />
          <span>{label_download}</span>
        </a>
        <div className={classNamesShareOpen.build()}>
          <button className="btn btn--white" onClick={this.toggleShare} aria-label="Partager">
            <i className="icon icon-share" />
          </button>
          <div className="share__wrapper">
            <i className="icon icon-delete" role="button" tabIndex={0} onClick={this.toggleShare} />
            {this.renderSocialButtons()}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CentenaireDownload;
